import { useMediaQuery, useTheme } from '@mui/material';
import Tickets from '../TicketsCustom';
import TicketAdvanced from '../TicketsAdvanced';

const TicketResponsiveContainer = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  if (isDesktop) {
    return <Tickets />;
  }
  return <TicketAdvanced />;
};

export default TicketResponsiveContainer;
